export default __webpack_public_path__ + "static/media/shadow-on-the-moon.c3e39130.png";